import { render, staticRenderFns } from "./groupEdit.vue?vue&type=template&id=6d07ade4&scoped=true&"
import script from "./groupEdit.vue?vue&type=script&lang=js&"
export * from "./groupEdit.vue?vue&type=script&lang=js&"
import style0 from "./groupEdit.vue?vue&type=style&index=0&id=6d07ade4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d07ade4",
  null
  
)

export default component.exports